import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-company-roc',
  templateUrl: './company-roc.component.html',
  styleUrls: ['./company-roc.component.scss'],
})
export class CompanyRocComponent implements OnInit {
  @Output() itemAddedToCart: EventEmitter<any> = new EventEmitter();
  @Input() all_data: any;
  @Input() cin: any;
  isPremium = false;
  plan: any;
  isAdvance = false;
  isFree = false;
  selectedYear;
  rocList: any;
  productList: any;
  visibleSidebar: boolean;
  roc_product_list;
  pls_product_list;
  bss_product_list;
  constructor(
    private localStorageService: LocalStorageService,
    private tansactionService: TansactionService,
    private toastService: ToastService
  ) {}
  ngOnInit(): void {
    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }

    if(this.all_data.cin == 'L72200DL2000PLC108985' || this.all_data.cin == 'L93030DL2010PLC198141'){
      this.isPremium = true;
      this.isAdvance = false;
      this.isFree = false;
      this.plan = 'plan_premium';
    }

    this.productList = this.all_data.product_list;

    // this.generateUnique(this.all_data.roc_product_list);
    this.generateUnique(this.all_data.pls_product_list);
    this.generateUnique(this.all_data.bss_product_list);
    this.ayList.sort(function (a, b) {
      return a.substring(0, 4) - b.substring(0, 4);
    });
    this.onOptionsSelected(this.ayList[this.ayList.length - 1]);
    // console.log(this.ayList);

    // var newArray = this.all_data.roc_product_list.filter((value, index, self) => {
    //   self.indexOf(value) === index
    // });
  }

  ayList = [];

  generateUnique(list) {
    list.forEach((product) => {
      if (product.enable && !this.ayList.includes(product.ay)) {
        this.ayList.push(product.ay);
      }
    });
  }

  clicked = false;

  addToCart(sku) {
    this.clicked = true;
    let currentOption;
    currentOption = {
      sku: sku,
    };
    this.tansactionService.addProductToCart(currentOption).then(
      (data: any) => {
        this.toastService.addSingle(
          'success',
          'Email Sent',
          'Please check your email.'
        );
      },
      (err) => {
        this.toastService.addSingle('error', 'Error', err.error.message);
      }
    );
  }

  onOptionsSelected(year) {
    this.selectedYear = year;
    this.roc_product_list = this.all_data.roc_product_list.filter((product) => {
      return product.ay === this.selectedYear;
    });
    this.pls_product_list = this.all_data.pls_product_list.filter((product) => {
      return product.ay === this.selectedYear;
    });
    this.bss_product_list = this.all_data.bss_product_list.filter((product) => {
      return product.ay === this.selectedYear;
    });
  }

  getFilteredBSS(year){
    return this.all_data.bss_product_list.filter((product) => {
      return product.ay === year;
    });
  }

  getFilteredPLS(year){
    return this.all_data.pls_product_list.filter((product) => {
      return product.ay === year;
    });
  }
}
